import {memo} from "react";
import {Tag} from "antd";
import dayjs from "dayjs";
import {Image, FontAwesomeIcon} from "~/components";
import DashboardWidgetHeader from "./DashboardWidgetHeader";

/**
 * Danh sách nhân sự sắp hết hạn (thử việc / hợp đồng lao động) cho dashboard.
 * Dùng chung cho DashboardPersonnel và DashboardCEO.
 *
 * Props:
 *  - items: mảng user (mỗi item có avatar, firstname, lastname, username + endTimeKey)
 *  - endTimeKey: tên field chứa timestamp hết hạn (vd 'phaseEndTime', 'contractEnd')
 *  - renderTag(item) => string; tagColor(item) => antd color
 *  - emptyText: text khi rỗng
 */
function ExpiringListWidget({title, icon, gradient, items = [], endTimeKey, renderTag, tagColor, emptyText}) {
	return (
		<div style={{borderRadius: 16, overflow: 'hidden', boxShadow: '0 2px 12px rgba(0,0,0,0.08)', background: '#fff'}}>
			<DashboardWidgetHeader
				icon={icon}
				title={title}
				gradient={gradient}
				badge={items.length > 0 ? `${items.length} người` : null}
			/>
			<div style={{padding: '12px 18px'}}>
				{items.length === 0 && (
					<div style={{textAlign: 'center', padding: '20px 0', color: '#94a3b8'}}>
						<FontAwesomeIcon icon={icon} style={{fontSize: 26, display: 'block', marginBottom: 6}} />
						<span style={{fontSize: 12}}>{emptyText}</span>
					</div>
				)}
				{items.map((item, index) => {
					const endTime  = item[endTimeKey] ? dayjs.unix(item[endTimeKey]) : null;
					const daysLeft = endTime ? endTime.diff(dayjs(), 'day') : null;
					const isLast   = index === items.length - 1;
					const isUrgent = daysLeft !== null && daysLeft <= 2;
					return (
						<div key={`exp-${item.id}-${index}`} style={{
							display: 'flex', gap: 10, alignItems: 'center',
							paddingBottom: isLast ? 4 : 12, marginBottom: isLast ? 0 : 12,
							borderBottom: isLast ? 'none' : '1px dashed #e2e8f0',
							...(isUrgent && {background: '#fff1f2', borderRadius: 10, padding: '8px 10px', margin: '0 -10px', borderBottom: isLast ? 'none' : '1px dashed #e2e8f0'}),
						}}>
							<div className="avatar" style={{width: 40, height: 40, flexShrink: 0}}><Image src={item.avatar} /></div>
							<div style={{flex: 1, minWidth: 0}}>
								<b style={{fontSize: 13, color: '#1e293b', display: 'block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>{item.firstname} {item.lastname}</b>
								<p style={{fontSize: 11, color: '#64748b', margin: 0}}>{item.username}</p>
							</div>
							<div style={{textAlign: 'right', flexShrink: 0}}>
								<Tag color={tagColor(item)} style={{fontSize: 10, margin: '0 0 2px', lineHeight: '18px'}}>{renderTag(item)}</Tag>
								<div style={{fontSize: 12, fontWeight: 600, color: isUrgent ? '#e11d48' : '#64748b'}}>
									{endTime ? endTime.format('DD/MM/YYYY') : '—'}
								</div>
								{daysLeft !== null && (
									<div style={{fontSize: 10, color: isUrgent ? '#e11d48' : '#94a3b8'}}>
										{daysLeft === 0 ? 'Hôm nay' : `còn ${daysLeft} ngày`}
									</div>
								)}
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
}

export default memo(ExpiringListWidget);
